import { Button } from "@/components/ui/button";

interface UnitReserveButtonProps {
    className?: string;
    label?: string;
    onReservationClick: () => void;
    dataState?: "open" | "closed";
    ariaControls?: string;
    // Explicit expanded state for the Layout 2 in-row toggle; falls back to dataState.
    ariaExpanded?: boolean;
}

export const ReserveButton = ({
    className = "reserve-btn",
    label = "Reserve",
    onReservationClick,
    dataState,
    ariaControls,
    ariaExpanded,
}: UnitReserveButtonProps) => {
    const expandedClass = dataState === "open" ? " expanded" : "";
    const resolvedAriaExpanded =
        ariaExpanded ?? (dataState === "open" ? true : undefined);

    return (
        <Button
            variant="secondary"
            data-testid="reserveButton"
            data-state={dataState}
            onClick={onReservationClick}
            className={`${className}${expandedClass}`}
            aria-label={label}
            aria-expanded={resolvedAriaExpanded}
            aria-controls={ariaControls}
            type="button"
        >
            {label}
        </Button>
    );
};

ReserveButton.displayName = "ReserveButton";
